export const EXTERNAL_HUBSPOT_SOURCE = 'https://js.hsforms.net/forms/v2.js';
